import { useState, useEffect } from 'react';

/**
 * Hook para detectar el tipo de dispositivo y resolución
 * Categoriza en: mobile, tablet, desktop-small, desktop-large
 */
export function useDeviceType() {
  const [deviceType, setDeviceType] = useState('desktop-large');

  useEffect(() => {
    const determineDeviceType = () => {
      const width = window.innerWidth;
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      const isMobileUA = /android|blackberry|iphone|ipad|ipod|opera mini|iemobile|wpdesktop/i.test(userAgent);
      const hasTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

      // Móvil real (hasta 768px)
      if (width <= 768 || (isMobileUA && width <= 1024)) {
        return 'mobile';
      }
      
      // Tablet o resolución pequeña con touch
      if (width <= 1024 && hasTouch) {
        return 'tablet';
      }
      
      // Desktop pequeño (1280x720, 1366x768, etc.)
      if (width <= 1366) {
        return 'desktop-small';
      }
      
      // Desktop grande (1920x1080+) - Vista PC original
      return 'desktop-large';
    };

    setDeviceType(determineDeviceType());

    const handleResize = () => {
      setDeviceType(determineDeviceType());
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return deviceType;
}

/**
 * Hook mejorado para móvil que considera más casos
 */
export function useIsMobile() {
  const deviceType = useDeviceType();
  return deviceType === 'mobile';
}

/**
 * Hook para saber si necesita layout compacto
 * (móvil, tablet, o desktop pequeño)
 */
export function useCompactLayout() {
  const deviceType = useDeviceType();
  return deviceType === 'mobile' || deviceType === 'tablet' || deviceType === 'desktop-small';
}

/**
 * Hook para saber si es desktop grande (1920x1080+)
 */
export function useIsDesktopLarge() {
  const deviceType = useDeviceType();
  return deviceType === 'desktop-large';
}